<template>
<div class="pilot-work-file-wrapper">
    <div class="nav-main-con">
        <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
        <span @click="toHome">首页</span>
        <span class="sp-nav-line">></span>
        <span v-if="xType == 'jdx'" class="sp-nav-link" @click="toXHome">酒店运营管理</span>
        <span v-if="xType == 'cyx'" class="sp-nav-link" @click="toXHome">餐饮管理运行</span>
        <span class="sp-nav-line">></span>
        <span>试点工作文件</span>
    </div>
    <div class="file-list-con">
        <div class="file-title-con">
            <span v-if="xType == 'jdx'">酒店运营管理</span>
            <span v-if="xType == 'cyx'">餐饮管理运行</span>
            <span>试点工作文件</span>
        </div>
        <ul v-if="fileList.length > 0">
            <li v-for="item in fileList" :key="item.id" class="clearfix file-li-item" @click="toFileDetail(item.docId)">
                <a :href="item.downloadUrl" :download="item.name" class="clearfix">
                    <i class="fl kd-icon-wenjian"></i>
                    <div class="fl file-name-con">{{item.name}}</div>
                    <span class="fr">{{item.dateCreated}}</span>
                </a>
            </li>
        </ul>
        <div v-else>
            <noData></noData>
        </div>
    </div>
</div>
</template>

<script>
import noData from 'components/noData.vue';
export default {
    data() {
        return {
            fileList: []
        }
    },
    components: {
        noData
    },
    props: {
        xType: {
            type: String,
            default: ''
        }
    },
    created() {
        this.getExamFileList();
    },
    methods: {
        toXHome() {
            this.$router.push({
                name: 'xView',
                params: {
                    xType: this.xType
                }
            });
        },
        toHome() {
            this.$router.push({
                name: 'xHome'
            });
        },
        toFileDetail(id) {
            this.$router.push({
                name: 'fileDocDetail',
                params: {
                    xType: this.xType,
                    fileId: id
                }
            });
        },
        getExamFileList() {
            var that = this;
            that.$http
                .post("/api/XOrg/homePage/getExamFileList", {
                    xType: this.xType,
                    type: 0
                })
                .then(rst => {
                    if (rst.code > 0) {
                        that.fileList = rst.fileList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        }
    }
}
</script>

<style lang="scss">
.pilot-work-file-wrapper {
    .nav-main-con {
        margin: 0 auto;
        width: 1200px;
        height: 40px;
        line-height: 40px;
        color: #333333;
        font-size: 14px;

        .sp-nav-line {
            margin: 0 6px;
        }

        .sp-nav-link {
            cursor: pointer;
        }

        .sp-nav-link:hover {
            color: #05243D;
        }
    }

    .file-list-con {
        margin: 0 auto 40px;
        padding: 20px 30px 50px 30px;
        width: 1200px;
        border: 1px solid #d3dbe5;
        box-sizing: border-box;

        .file-title-con {
            margin-bottom: 20px;
            color: #05243D;
            font-size: 18px;
            font-weight: bold;
        }

        .file-li-item {
            margin-top: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #d3dbe5;
            cursor: pointer;

            .kd-icon-wenjian {
                margin-right: 6px;
                font-size: 19px;
                font-weight: bold;
                color: #05243D;
            }

            a {
                display: block;
            }
        }

        .file-li-item:hover {
            color: #05243D;
        }
    }
}

@media only screen and (max-width: 768px) {
    .pilot-work-file-wrapper {
        .nav-main-con {
            padding: 0 20px;
            width: 100%;
            font-size: 13px;

        }

        .file-list-con {
            width: 100%;
            padding: 10px 15px;
            background: #fff;
            box-sizing: border-box;

            .file-title-con {
                font-size: 16px;
            }

            .file-name-con {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: calc(100% - 120px);
            }
        }
    }
}
</style>
